import App from '@/models/App'

export default class ShipSailorInfoSkillHistory extends App {
    static get entity() {
        return 'ShipSailorInfoSkillHistories'
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipSailorId: this.attr(''),
            skill: this.attr(''),
            openedAt: this.attr(''),
            closedAt: this.attr(''),
            modifyName: this.attr(''),
            isDeleted: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static filterBySailorId(sailorId) {
        return this.query()
            .where('shipSailorId', sailorId)
            .orderBy('openedAt', 'desc')
            .get()
    }

    static getOtherHistories(shipSailorId, skillHistoryId) {
        return this.query()
            .where((value) => {
                return (
                    value.shipSailorId === shipSailorId &&
                    value.id !== skillHistoryId &&
                    value.isDeleted === false
                )
            })
            .withAllRecursive()
            .get()
    }

    static apiConfig = {
        actions: {
            fetch(shipId, shipSailorId) {
                return this.get(
                    `${shipId}/sailors/${shipSailorId}/infos/skill/histories`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(shipId, shipSailorId, shipSailorInfoSkillHistoryId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/infos/skill/histories/${shipSailorInfoSkillHistoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, shipSailorId, shipSailorInfoSkillHistoryId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipId}/sailors/${shipSailorId}/infos/skill/histories/${shipSailorInfoSkillHistoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: shipSailorInfoSkillHistoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
